import { findADate } from './helpers';

export const getDatePickerFieldValue = (defaultValue: unknown) => {
	if (findADate(defaultValue)) return findADate(defaultValue)?.slice(0, 10);
	return null;
};

export const getDateTimePickerFieldValue = (defaultValue: unknown) => {
	return findADate(defaultValue);
};
